import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import LayoutContentArea from "@/components/layout/LayoutContentArea";
import { Report2_1 } from "../report-2-1/Reports2_1";
import { Report2_2 } from "../report-2-2/Reports2_2";

interface ReportOption {
  value: string;
  label: string;
  disabled?: boolean;
}

const REPORT_OPTIONS: ReportOption[] = [
  { value: "2.1", label: "2.1 – Certification Cycle Status" },
  { value: "2.2", label: "2.2 – User Management Extract" },
];

const labelStyle: React.CSSProperties = {
  fontSize: "0.72rem",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#374151",
  fontWeight: 700,
  marginBottom: "4px",
  display: "block",
};

function UnderConstruction() {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: 220,
        color: "#6c757d",
        fontSize: "0.95rem",
        textAlign: "center",
        padding: "3rem 1rem",
      }}
    >
      This report is under construction. Please check back soon.
    </div>
  );
}

const StateLevelReportsPage = () => {
  const search = useSearch({ from: "/$leaid/_error-wrapper/admin/reports" });
  const navigate = useNavigate();

  const selectedReport = REPORT_OPTIONS.some(
    (opt) => opt.value === search.report
  )
    ? (search.report as string)
    : REPORT_OPTIONS[0].value;

  const handleReportChange = (value: string) => {
    navigate({ to: ".", search: (prev) => ({ ...prev, report: value }) });
  };

  const renderReport = () => {
    switch (selectedReport) {
      case "2.1":
        return <Report2_1 />;
      case "2.2":
        return <Report2_2 />;
      default:
        return <UnderConstruction />;
    }
  };

  return (
    <LayoutContentArea headingText="State Level Reports">
      <div className="mb-4" style={{ maxWidth: "420px" }}>
        <label style={labelStyle} htmlFor="report-select">
          Select Report
        </label>
        <select
          id="report-select"
          className="form-select"
          style={{
            fontSize: "0.925rem",
            color: "#0f1923",
            fontWeight: 500,
            cursor: "pointer",
          }}
          value={selectedReport}
          onChange={(e) => handleReportChange(e.target.value)}
        >
          {REPORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {renderReport()}
    </LayoutContentArea>
  );
};

export default StateLevelReportsPage;
